import React, { useEffect, useState } from "react";
import { IoMdExit } from "react-icons/io";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import Select, { components } from "react-select";
import SwitchCustom from "react-switch";
import { Flex } from "rebass";
import { Avatar } from "../components";
import { Settings } from "../components/settings";
import ChecvronDown from "../icons/ChevronDown";
import { systemActions, userActions } from "../logic/actions";
import FvlLogo from "../static/images/FvlLogoDev.png";
import { getLocalizedString } from "../utils";

const languages = {
  ITA: {
    name: "ITA",
  },
  ENG: {
    name: "ENG",
  },
};

const HeaderFvl = () => {
  const { me } = useSelector((state) => state.yodaStakeholders);
  const location = useLocation();
  const currentPath = location.pathname.toLowerCase();
  const { hidePrice } = useSelector((state) => state.system);
  const dispatch = useDispatch();
  const navigate = useHistory();
  const [changeCustomerPermission, setChangeCustomerPermission] =
    useState(false);
  const [showSettings, setShowSettings] = useState(false);

  let tmpLanguageValue = localStorage.getItem("B2BLanguage");
  var languageValue;

  if (tmpLanguageValue) {
    languageValue = {
      key: tmpLanguageValue,
      label: tmpLanguageValue,
    };
  } else {
    languageValue = {
      key: "ITA",
      label: "ITA",
    };

    localStorage.setItem("B2BLanguage", "ITA");
  }

  const changeHidePrice = () => {
    localStorage.setItem("hidePrice", !hidePrice);
    if (hidePrice) {
      dispatch(systemActions.setHidePrice(false));
    } else {
      dispatch(systemActions.setHidePrice(true));
    }
  };

  const toggleSettings = () => {
    setShowSettings(!showSettings);
  };

  return (
    <Flex
      style={{ width: "100%", position: "relative" }}
      bg="#44494d"
      alignItems="center"
      justifyContent="space-between"
      pl="15px"
    >
      <Flex alignItems={"center"} style={{ gap: "10px" }}>
        {me && (
          <Avatar id="avatar" name={`${me.firstName} ${me.lastName}`} mr={2} />
        )}
        <Link
          style={{
            textDecoration: "none",
            color: "#fff",
            fontSize: "14px",
            fontFamily: "Open Sans",
          }}
          to={"/users/" + localStorage.getItem("selectedAgent")}
        >
          {getLocalizedString("CAMBIA CLIENTE")}
        </Link>
        <Flex alignItems="center" minWidth="65px">
          {currentPath !== "/privacy" && currentPath !== "/cookie" && (
            <>
              <Flex alignItems="center">
                <SwitchCustom
                  checkedIcon={false}
                  uncheckedIcon={false}
                  checked={hidePrice}
                  onChange={changeHidePrice}
                  onColor="#fff"
                  offColor="#fff"
                  onHandleColor="#44494d"
                  offHandleColor="#44494d"
                  height={18}
                  width={36}
                />
              </Flex>
              <span
                style={{
                  marginLeft: "8px",
                  fontFamily: "Open Sans",
                  color: "white",
                  fontSize: "14px",
                  cursor: "pointer",
                }}
                onClick={changeHidePrice}
              >
                {hidePrice ? "$$$" : "***"}
              </span>
            </>
          )}
        </Flex>
      </Flex>
      <Flex style={{ position: "relative", right: "5%" }} py="5px">
        <img src={FvlLogo} style={{ height: "40px" }} alt="fvl-logo" />
      </Flex>
      <Flex pr="15px" alignItems="center">
        <Select
          styles={{
            control: (styles) => ({
              ...styles,
              border: 0,
              borderRadius: 0,
              backgroundColor: "transparent",
              fontSize: "1em",
              boxShadow: "none",
              color: "#fff",
              marginRight: 10,
            }),
            menu: (styles) => ({
              ...styles,
              border: 12,
              padding: 0,
              borderRadius: 0,
              fontSize: "1em",
              marginTop: 0,
              marginBottom: 0,
              boxShadow: "none",
              zIndex: 10000,
            }),
            option: (styles) => ({
              ...styles,
            }),
            placeholder: (styles) => ({ ...styles, color: "#fff" }),
            singleValue: (styles, { data }) => ({
              ...styles,
              color: "#fff",
            }),
          }}
          name="language"
          components={{
            IndicatorSeparator: () => null,
            DropdownIndicator: (props) => (
              <components.DropdownIndicator {...props}>
                <ChecvronDown
                  style={{ width: 18, height: 18, color: "#fff" }}
                />
              </components.DropdownIndicator>
            ),
          }}
          onChange={(evt) => {
            localStorage.setItem("B2BLanguage", evt.value);
            navigate.push(navigate.location.pathname);
          }}
          options={Object.entries(languages).map(([key, language]) => ({
            value: key,
            label: language.name,
          }))}
          defaultValue={
            languageValue ||
            Object.entries(languages).map(([key, language]) => ({
              value: key,
              label: language.name,
            }))[0]
          }
          isSearchable={false}
        ></Select>

        {showSettings && <Settings hideSettings={() => toggleSettings()} />}

        <Link
          p={2}
          to="#"
          onClick={(e) => {
            e.preventDefault();
            dispatch(userActions.logout());
          }}
        >
          <IoMdExit size="24px" color="white" />
        </Link>
      </Flex>
    </Flex>
  );
};

export default HeaderFvl;
